var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronEmails = function SvgChevronEmails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.556 10.573-1.101-1.1-7.268 7.269-7.269-7.27-1.1 1.101 8.37 8.368z",
    fill: "#B7B7B7",
    fillRule: "evenodd"
  })));
};
export { SvgChevronEmails as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0yMi41NTYgMTAuNTczLTEuMTAxLTEuMS03LjI2OCA3LjI2OS03LjI2OS03LjI3LTEuMSAxLjEwMSA4LjM3IDguMzY4eiIgZmlsbD0iI0I3QjdCNyIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";